export const fdefFormANew = {
  __renderer: 'new',
  formdefinition: [
    {
      control: 'stepper',
      name: 'schadensmeldung',
      label: 'Schadenanzeige - Dienstreise - Kasko',
      cols: '12',
      steps: [
        {
          label: 'Vertragsdaten',
          description: 'Der Schaden wird für folgenden Vertrag gemeldet.',
          children: [
            {
              control: 'input',
              name: 'vertragsnummer',
              label: 'Vertragsnummer',
              disabled: true,
              cols: '6',
            },
            {
              control: 'input',
              name: 'gesellschaft',
              label: 'Gesellschaft',
              disabled: true,
              cols: '6',
            },
          ],
        },
        {
          label: 'Schaden',
          description:
            'Die Frage, \'Was ist passiert?\', ist entscheidend, um den Versicherungsschaden korrekt zu bearbeiten. Bitte beschreiben Sie den Vorfall so ausführlich wie möglich. Wo und wann ist er passiert? Welche Umstände haben dazu geführt? Welche Schäden sind aufgetreten? Ihre genaue Beschreibung hilft dem Versicherer, den Schadensfall effizient zu prüfen und die Ansprüche Ihres Mandante zu bearbeiten. Je mehr Informationen Sie bereitstellen, desto besser kann der Versicherer Ihren Schaden prüfen.',
          children: [
            {
              control: 'input',
              name: 'schaden_nummer_kd',
              label: 'eigene Vorgangsnummer',
              cols: '12',
            },
            {
              control: 'datepicker',
              name: 'schaden_datum',
              label: 'Schadensdatum',
              valid: [
                { fn: 'required' },
                { fn: 'max_date_today', message: 'Das Schadensdatum darf nicht in der Zukunft liegen.' },
              ],
              cols: '6',
            },
            {
              control: 'timepicker',
              name: 'schaden_uhrzeit',
              label: 'Uhrzeit',
              cols: '6',
            },
            {
              control: 'switch',
              name: 'grossschaden',
              label: 'Großschaden',
              cols: '12',
            },
            {
              control: 'textarea',
              name: 'schaden_ort',
              label: 'Schadenort',
              cols: '12',
            },
            {
              control: 'textarea',
              name: 'schaden_adresszusatz',
              label: 'Adresszusatz',
              cols: '12',
            },
            {
              control: 'input',
              name: 'schaden_besichtigung_adresse',
              label: 'Besichtigung (Adresse)',
              cols: '12',
            },
            {
              control: 'textarea',
              name: 'schaden_schilderung',
              label: 'Schilderung des Hergangs',
              valid: [{ fn: 'required' }],
              cols: '12',
            },
            {
              control: 'autocomplete',
              name: 'schaden_ursache',
              label: 'Ursache des Schadens',
              valid: [{ fn: 'required' }],
              cols: '12',
              get_api: {
                endpoint: 'data/schaden_ursachen_select',
                map_result: { key: 'id', label: 'label' },
              },
            },
            {
              control: 'textarea',
              name: 'schaden_zeugen',
              label: 'Zeugen',
              cols: '12',
            },
            {
              control: 'textarea',
              name: 'schaden_zweck_fahrt',
              label: 'Zweck der Fahrt',
              cols: '12',
            },
            {
              control: 'sbwarning',
              betrag: ['schaden_rechnungsbetrag', 'schaden_kostenvoranschlag', 'schaden_hoehe'],
            },
            {
              control: 'numberinput',
              unit_type: 'currency',
              unit: '€',
              allow_negative: false,
              name: 'schaden_hoehe',
              label: 'Schadenhöhe (eigene Schätzung)',
              valid: [{ fn: 'required_when', field: 'grossschaden', equals: true }],
              cols: { xxl: 4 },
            },
            {
              control: 'numberinput',
              unit_type: 'currency',
              unit: '€',
              allow_negative: false,
              name: 'schaden_kostenvoranschlag',
              label: 'Schadenhöhe (Kostenvoranschlag)',
              cols: { xxl: 4 },
            },
            {
              control: 'numberinput',
              unit_type: 'currency',
              unit: '€',
              allow_negative: false,
              name: 'schaden_rechnungsbetrag',
              label: 'Schadenhöhe (Rechnung)',
              cols: { xxl: 4 },
            },
            {
              control: 'switch',
              name: 'schaden_abtretungserklärung',
              label: 'Abtretungserklärung liegt vor ja/nein',
              cols: '12',
            },
            {
              control: 'switch',
              name: 'schaden_totalschaden',
              label: 'Totalschaden',
              cols: '12',
            },
            {
              control: 'switch',
              name: 'schaden_personenschaden',
              label: 'eine Person wurde geschädigt',
              cols: '12',
            },
            {
              control: 'textarea',
              name: 'schaden_beschaedigte_sache',
              label: 'Was wurde beschädigt?',
              cols: '12',
            },
            {
              control: 'textarea',
              name: 'schaden_beschaedigte_teile',
              label: 'Welche Teile wurden beschädigt?',
              cols: '12',
            },
            {
              control: 'switch',
              name: 'schaden_fremdschaden',
              label: 'Fremdschäden',
              cols: '6',
            },
            {
              control: 'switch',
              name: 'schaden_vorschaeden',
              label: 'Vorschäden',
              cols: '6',
            },
            {
              control: 'switch',
              name: 'schaden_vorschaeden_repariert',
              label: 'Vorschäden wurden repariert',
              cols: '6',
            },
          ],
        },
        {
          label: 'Polizei',
          description:
            'Falls der Unfall polizeilich aufgenommen wurde, benötigen wir weitere Details.',
          children: [
            {
              control: 'switch',
              name: 'polizei_aufgenommen',
              label: 'polizeiliche Aufnahme ist erfolgt',
              cols: '12',
            },
            {
              control: 'input',
              name: 'polizei_dienststelle',
              label: 'Dienststelle',
              cols: '12',
              hidden: { when: { field: 'polizei_aufgenommen', truthy: false } },
            },
            {
              control: 'input',
              name: 'polizei_tagebuchnummer',
              label: 'Aktenzeichen/Tagebuchnummer',
              cols: '12',
              hidden: { when: { field: 'polizei_aufgenommen', truthy: false } },
            },
            {
              control: 'switch',
              name: 'polizei_alkohol_drogen',
              label: 'Konsum von Alkohol oder Drogen',
              cols: '6',
              hidden: { when: { field: 'polizei_aufgenommen', truthy: false } },
            },
            {
              control: 'switch',
              name: 'polizei_blutprobe',
              label: 'Blutprobe wurde entnommen',
              cols: '6',
              hidden: {
                any: [
                  { when: { field: 'polizei_aufgenommen', equals: false } },
                  { when: { field: 'polizei_alkohol_drogen', equals: false } },
                ],
              },
            },
            {
              control: 'claim_attachments',
              name: 'polizei',
              label: 'polizeiliche Meldung',
              multiple: false,
              add_description: false,
              track_as_source: true,
              cols: '12',
              hidden: {
                any: [
                  { when: { field: 'polizei_aufgenommen', equals: false } },
                  { when: { field: 'polizei_alkohol_drogen', equals: false } },
                ],
              },
            },
          ],
        },
        {
          label: 'Fahrzeug',
          description: '',
          children: [
            {
              control: 'input',
              name: 'fahrzeug_kennzeichen',
              label: 'Kennzeichen',
              cols: '4',
            },
            {
              control: 'input',
              name: 'fahrzeug_marke',
              label: 'Marke',
              cols: '4',
            },
            {
              control: 'input',
              name: 'fahrzeug_modell',
              label: 'Modell',
              cols: '4',
            },
            {
              control: 'datepicker',
              name: 'fahrzeug_erstzulassung',
              label: 'Datum der Erstzulassung',
              cols: '4',
            },
            {
              control: 'numberinput',
              unit_type: 'currency_no_digit',
              unit: 'KW',
              allow_negative: false,
              name: 'fahrzeug_kw',
              label: 'KW',
              cols: '4',
            },
            {
              control: 'numberinput',
              unit_type: 'currency_no_digit',
              unit: 'km',
              allow_negative: false,
              name: 'fahrzeug_km',
              label: 'Laufleistung in km',
              cols: '4',
            },
            {
              control: 'switch',
              name: 'fahrzeug_verpfendet',
              label: 'verpfändet/übereignet',
              cols: '6',
            },
            {
              control: 'switch',
              name: 'fahrzeug_leasing',
              label: 'Leasingfahrzeug',
              cols: '6',
            },
          ],
        },
        {
          label: 'Fahrzeughalter',
          description: '',
          children: [
            {
              control: 'input',
              name: 'fahrzeughalter_vorname',
              label: 'Vorname',
              cols: '6',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_name',
              label: 'Nachname',
              valid: [{ fn: 'required' }],
              cols: '6',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_strasse',
              label: 'Strasse',
              valid: [{ fn: 'required' }],
              cols: '8',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_hausnummer',
              label: 'Hausnummer',
              valid: [{ fn: 'required' }],
              cols: '2',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_land',
              label: 'Land',
              cols: '2',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_plz',
              label: 'PLZ',
              valid: [{ fn: 'required' }],
              cols: '4',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_ort',
              label: 'Ort',
              valid: [{ fn: 'required' }],
              cols: '8',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_telefon_mobil',
              label: 'Telefon mobil',
              cols: '6',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_email',
              label: 'E-Mail',
              valid: [{ fn: 'required' }, { fn: 'email' }],
              cols: '6',
            },
            {
              control: 'info',
              label: 'Wo ist das Fahrzeug versichert?',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_vertragsnummer',
              label: 'Vertragsnummer',
              cols: '6',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_gesellschaft',
              label: 'Gesellschaft',
              cols: '6',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_sb_vollkasko',
              label: 'Selbstbeteiligung Vollkasko',
              cols: '6',
            },
            {
              control: 'input',
              name: 'fahrzeughalter_sb_teilkasko',
              label: 'Selbstbeteiligung Teilkasko',
              cols: '6',
            },
          ],
        },
        {
          label: 'Fahrer',
          description: '',
          children: [
            {
              control: 'switch',
              name: 'fahrer_identisch_halter',
              label: 'Fahrer gleichzeitig Fahrzeughalter',
              default: true,
              cols: '12',
            },
            {
              control: 'input',
              name: 'fahrer_vorname',
              label: 'Vorname',
              cols: '6',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_name',
              label: 'Nachname',
              valid: [{ fn: 'required' }],
              cols: '6',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_strasse',
              label: 'Strasse',
              valid: [{ fn: 'required' }],
              cols: '8',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_hausnummer',
              label: 'Hausnummer',
              valid: [{ fn: 'required' }],
              cols: '2',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_land',
              label: 'Land',
              cols: '2',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_plz',
              label: 'PLZ',
              valid: [{ fn: 'required' }],
              cols: '4',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_ort',
              label: 'Ort',
              valid: [{ fn: 'required' }],
              cols: '8',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_telefon_mobil',
              label: 'Telefon mobil',
              cols: '6',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_email',
              label: 'E-Mail',
              valid: [{ fn: 'required' }, { fn: 'email' }],
              cols: '6',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_fuehrerschein_klasse',
              label: 'Führerscheinklasse',
              valid: [{ fn: 'required' }],
              cols: '4',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'datepicker',
              name: 'fahrer_fuehrerschein_ausstellungsdatum',
              label: 'Ausstellungsdatum Führerschein',
              valid: [{ fn: 'required' }],
              cols: '4',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
            {
              control: 'input',
              name: 'fahrer_fuehrerschein_nummer',
              label: 'Führerscheinnummer',
              valid: [{ fn: 'required' }],
              cols: '4',
              hidden: { when: { field: 'fahrer_identisch_halter', equals: true } },
            },
          ],
        },
        {
          label: 'Auszahlung Fahrzeughalter',
          description:
            'Was wird vermisst bzw. beschädigt? Geben Sie bitte auch den Wert und das Anschaffungsdatum an.',
          children: [
            {
              control: 'select',
              name: 'auszahlung_an',
              label: 'Auszahlung an',
              cols: '4',
              options: [
                { key: 'Fahrzeughalter', label: 'Fahrzeughalter' },
                { key: 'Dienstherrn', label: 'Dienstherrn' },
                { key: 'Dritter', label: 'Dritter' },
              ],
              default: 'Fahrzeughalter',
            },
            {
              control: 'switch',
              name: 'vorsteuerabzugsberechtigt',
              label: 'Vorsteuerabzugsberechtigt',
              cols: '12',
            },
            {
              control: 'input',
              name: 'auszahlung_geschaedigter_kontoinhaber',
              label: 'Kontoinhaber',
              valid: [{ fn: 'required' }],
              cols: '12',
            },
            {
              control: 'input',
              name: 'auszahlung_geschaedigter_bank',
              label: 'Bank (Name)',
              valid: [{ fn: 'required' }],
              cols: '12',
            },
            {
              control: 'input',
              name: 'auszahlung_geschaedigter_iban',
              label: 'IBAN',
              valid: [{ fn: 'iban' }],
              cols: '6',
            },
            {
              control: 'input',
              name: 'auszahlung_geschaedigter_bic',
              label: 'BIC',
              cols: '6',
            },
          ],
        },
        {
          label: 'Ansprechpartner',
          description: '',
          children: [
            {
              control: 'input',
              name: 'ansprechpartner_vorname',
              label: 'Vorname',
              cols: '6',
            },
            {
              control: 'input',
              name: 'ansprechpartner_name',
              label: 'Nachname',
              valid: [{ fn: 'required' }],
              cols: '6',
            },
            {
              control: 'input',
              name: 'ansprechpartner_telefon',
              label: 'Telefon',
              valid: [{ fn: 'required' }],
              cols: '6',
            },
            {
              control: 'input',
              name: 'ansprechpartner_mobil',
              label: 'Mobilnummer (wird bevorzugt)',
              cols: '6',
            },
            {
              control: 'input',
              name: 'ansprechpartner_email',
              label: 'E-Mail',
              valid: [{ fn: 'required' }, { fn: 'email' }],
              cols: '6',
            },
          ],
        },
        {
          label: 'Anhänge',
          description: '',
          children: [
            {
              control: 'claim_attachments',
              name: 'sonstiges_unterlagen',
              label:
                'z.B. Farbfotos inkl. Kennzeichen, Kostenvoranschlag, Reparaturrechnung; maximale Größe von 15MB. Ohne Rechnungen und Schadenfotos kann der Schaden nicht zur Prüfung gemeldet werden',
              multiple: true,
              add_description: true,
              show_other_field_files: true,
              prevent_selecting_other_field_files: true,
              cols: '12',
            },
            {
              control: 'info',
              label: 'Welche Unterlagen haben Sie hochgeladen?',
              text: 'Diese Liste dient zur Überprüfung',
            },
            {
              control: 'radiogroup',
              name: 'schadenfotos',
              label: 'Schadenfotos',
              valid: [{ fn: 'required' }],
              cols: '12',
              options: [
                { key: 'hochgeladen', label: 'hochgeladen' },
                { key: 'Schaden_bereits_behoben', label: 'Schaden bereits behoben' },
                { key: 'Erstellung_nicht_moeglich', label: 'Erstellung nicht möglich' },
              ],
            },
            {
              control: 'checkbox',
              name: 'kostenvoranschlag',
              label: 'Kostenvoranschlag/Rechnung',
              valid: [{ fn: 'must_be_true', message: 'Kostenvoranschlag oder Rechnung sollte hochgeladen werden' }],
              default: false,
            },
            {
              control: 'checkbox',
              name: 'leckortungsbericht',
              label: 'Leckortungsbericht',
            },
            {
              control: 'checkbox',
              name: 'abtretungserklaerung',
              label: 'Abtretungserklärung',
            },
          ],
        },
        {
          label: 'Abschluß',
          description: '',
          children: [
            {
              control: 'switch',
              name: 'alles_korrekt',
              label:
                'Die vorstehenden Angaben habe(n) ich/wir wahrheitsgetreu und nach bestem Wissen und Gewissen gemacht. Der Versicherungsnehmer ist für die Richtigkeit der Angaben verantwortlich, auch wenn eine andere Person ihre Niederschrift vornimmt. Bewusst unwahre oder unvollständige Angaben führen auch dann zum Verlust des Versicherungsschutzes, wenn dem Versicherer dadurch kein Nachteil entsteht. Der Versicherer ist bevollmächtigt, bei Behörden in alle diesen Vorfall betreffenden Akten einzusehen und ggf. Abschriften anzufertigen. Wir sind damit einverstanden, dass die Abwicklung ohne vorherige Information ggf. direkt mit den Geschädigten erfolgen kann.',
              cols: '12',
              valid: [{ fn: 'must_be_true', message: 'Die Bestätigung ist verpflichtend' }],
            },
          ],
        },
      ],
    },
  ],
  transformIn: [
    { fn: 'copyIfEmpty', source: 'user.vorname', target: 'ansprechpartner_vorname' },
    { fn: 'copyIfEmpty', source: 'user.nachname', target: 'ansprechpartner_name' },
    { fn: 'copyIfEmpty', source: 'user.telefon', target: 'ansprechpartner_telefon' },
    { fn: 'copyIfEmpty', source: 'user.email', target: 'ansprechpartner_email' },
  ],
};
